import PropTypes from 'prop-types';
import {
  DndContext,
  closestCenter,
} from '@dnd-kit/core';
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import useDndSensors from '#/hooks/useDnd';

const DndSortableList = ({
  items,
  getItemId,
  onReorder,
  children,
  className = '',
}) => {
  const sensors = useDndSensors();
  const itemIds = items.map((item) => getItemId(item));

  function handleDragEnd(event) {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = itemIds.indexOf(active.id);
    const newIndex = itemIds.indexOf(over.id);

    if (oldIndex < 0 || newIndex < 0) {
      return;
    }

    onReorder(arrayMove(items, oldIndex, newIndex));
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
        <div className={className}>
          {children}
        </div>
      </SortableContext>
    </DndContext>
  );
};

DndSortableList.propTypes = {
  items: PropTypes.array.isRequired,
  getItemId: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DndSortableList;
